import { Route } from 'vue-router';
import { trackSiftPageview } from '../../lib/sift';

const siftPageviews = (_to: Route, _from: Route) => {
  try {
    trackSiftPageview();
  } catch (error) {
    console.error('Sift tracking failed:', error);
  }
};

export default siftPageviews;
